import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// modules 自动化
const modulesFiles = require.context('./modules', false, /\.js$/)
const modules = modulesFiles.keys().reduce((modulesTemp, modulePath) => {
  // set './user.js' => 'user'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modulesTemp[moduleName] = value.default
  return modulesTemp
}, {})

const store = new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      filter: mutation => {
        //  FIXME 暂时禁止缓存订单详情
        if (mutation.type === 'loan/SET_LOAN_DETAIL') {
          return false
        }
        return true
      }
    })
  ]
})

export default store
